import React from 'react'

import './MenuItem.scss'
import {useNavigate} from "react-router-dom";
import {ProductModel} from "../../Models/ProductModel";
import {useDispatch} from "react-redux";
import {setProductToShow} from "../../store/actions";
import {useGetDiscount} from "../../hooks/useGetDiscount";

interface MenuItemProps {
    item: ProductModel,
}

const MenuItem: React.FC<MenuItemProps> = ({item}: MenuItemProps) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const getDiscount = useGetDiscount()

    const discount = getDiscount(item.automaticDiscounts, new Date())

    const handleClick = () => {
        dispatch(setProductToShow(item))
        navigate(`/produit`)
    }

    const getQuantityDiscountText = () => {
        if(discount) {
            const achete = discount.discount.rate > 1 ? "achetés" : "acheté"
            const offert = discount.discount.rateTotal - discount.discount.rate > 1 ? "offerts" : "offert"
            return `${discount.discount.rate} ${achete} = ${discount.discount.rateTotal - discount.discount.rate} ${offert}`
        }
        return ''
    }

    return (
        <div className="menuItem" onClick={handleClick}>
            <div className="menuItem__cadre">
                {
                    discount && (
                        <div className={`menuItem__cadre__discount ${discount.discount.type === 'quantity' ? 'quantity' : 'percent'}`}>
                            {
                                discount.discount.type === 'quantity' ? (
                                    <p>{getQuantityDiscountText()}</p>
                                ) : (
                                    <p>-{discount.discount.rate}%</p>
                                )
                            }
                        </div>
                    )
                }
                <div className="menuItem__cadre__imgContainer">
                    <img
                        src={item.product.image}
                        alt="item"
                    />
                </div>
            </div>
            <p className="menuItem--name">{item.product.name}</p>
            {
                discount && discount.discount.type === 'percent' ? (
                    <p className="menuItem--prix">{(item.priceTTC - (item.priceTTC * (discount.discount.rate / 100))).toFixed(2)} € <span>{item.priceTTC} €</span></p>
                ) : (
                    <p className="menuItem--prix">{item.priceTTC} €</p>
                )
            }
        </div>
    )
}

export default MenuItem;
